import { isDev } from '@restworld/utils-common';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import 'twin.macro';
import { ButtonV2 } from '@restworld/ui-ds';

export function Index() {
  const router = useRouter();

  useEffect(() => {
    // Redirect to the dashboard page
    if (!isDev && !router.asPath.includes('dev.employer.restworld.it')) {
      router.replace('/employer/homepage');
    }
  }, [router]);
  /*
   * Replace the elements below with your own.
   *
   * Note: The corresponding styles are in the ./index.styled-components file.
   */
  return (
    <div>
      <div tw="flex justify-center p-6 bg-purple-100">
        <h1 tw="text-6xl font-bold text-center text-neutral">Welcome to the employer app!</h1>
      </div>
      <div tw="flex items-center justify-center mt-20">
        <ButtonV2 variant="tertiary" onClick={() => router.push('/dev/login')}>
          Dev Login
        </ButtonV2>
      </div>
    </div>
  );
}

export default Index;
